import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, BiReport, inject, PowerBIStore, SubTopBar, Title } from 'Mri.Web.Common';
import * as pbi from 'powerbi-client';
import * as React from 'react';
import { BsFileText } from '@react-icons/all-files/bs/BsFileText';
import { RouteComponentProps } from 'react-router';
import { AppStore } from '../Core/AppStore';

declare let powerbi: pbi.service.Service;

export interface IReportViewParams {
    reportId: string;
}
export interface IReportViewProps extends RouteComponentProps<IReportViewParams> {}

@autoinject
@observer
export class ReportView extends React.Component<IReportViewProps> {
    @action
    public async componentDidMount() {
        this.loading = true;

        try {
            await this.powerBIStore.loadPowerBiReportAsync(this.props.match.params.reportId, {
                params: { provision: false },
            });
        } catch (e: any) {
            this.appStore.notificationHandle.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid p-0 h-100">
                <Title>{this.report?.report?.name ?? this.props.match.params.reportId}</Title>

                <SubTopBar>
                    <button className="btn btn-sm btn-primary" onClick={this.printReport}>
                        <BsFileText /> Print Report
                    </button>

                    {this.appStore.hiddenHeader && (
                        <button className="btn btn-sm btn-primary ms-2" onClick={this.appStore.showHeader}>
                            Show Header
                        </button>
                    )}

                    {!this.appStore.hiddenHeader && (
                        <button className="btn btn-sm btn-primary ms-2" onClick={this.appStore.hideHeader}>
                            Hide Header
                        </button>
                    )}
                </SubTopBar>

                <BiReport
                    type="report"
                    reportOrDashboardId={this.props.match.params.reportId}
                    darkTheme={this.appStore.storage.theme == 'dark-theme'}
                    onEmbedded={this.onEmbedded}
                />
            </div>
        );
    }

    @bind
    @action
    private onEmbedded(embed: pbi.Report) {
        this.reportComponent = embed;
    }

    @bind
    @action
    private async printReport() {
        const r = this.reportComponent;
        if (r)
            try {
                await r.print();
            } catch (e: any) {
                console.log(e);
            }
    }

    @computed
    private get report() {
        return this.powerBIStore.reports.get(this.props.match.params.reportId);
    }

    private reportComponent?: pbi.Report;
    @observable
    private loading = false;
    @inject
    private appStore!: AppStore;
    @inject
    private powerBIStore!: PowerBIStore;
}
